import type { PropsWithChildren } from 'react';
import { useAuth } from '../../hook/Api/Auth';
import { useProject } from '../../provider/ProjectProvider';
import { isMfaRequiredError, isSsoRequiredError } from '../../utils/authRequirements';
import { isProjectIpRestrictedError } from '../../utils/projectIpRestriction';
import { IpRestricted } from './IpRestricted';

export const ProjectIpGuard = ({ children }: PropsWithChildren) => {
  const { project } = useProject();
  const { isAllowedIp, isPending, error } = useAuth.IsAllowedIp({ projectId: project.id });

  if (isPending) return null;
  if (isSsoRequiredError(error) || isMfaRequiredError(error)) return null;
  if (isProjectIpRestrictedError(error)) return <IpRestricted />;

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center px-8 py-10 max-sm:px-6">
        <main className="max-w-lg text-center" role="alert">
          <h1 className="mb-4 text-2xl font-bold">アクセスを確認できませんでした</h1>
          <p className="text-base leading-7 max-md:text-sm">
            ネットワーク接続を確認して、ページを再読み込みしてください。
            <br />
            改善しない場合は、管理者にお問い合わせください。
          </p>
          <button type="button" className="mt-6 rounded border px-4 py-2 text-base font-bold" onClick={() => window.location.reload()}>
            ページを再読み込み
          </button>
        </main>
      </div>
    );
  }

  if (isAllowedIp === false) return <IpRestricted />;
  if (isAllowedIp !== true) return null;
  return children;
};
